var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import { SkeletonElement, DefaultWrapper } from './elements';
export var Skeleton = forwardRef(function (_a, fRef) {
    var _b = _a.wrapper, Wrapper = _b === void 0 ? DefaultWrapper : _b, height = _a.height, _c = _a.width, width = _c === void 0 ? 'auto' : _c, _d = _a.elementCount, elementCount = _d === void 0 ? 1 : _d, _e = _a.duration, duration = _e === void 0 ? 1500 : _e, _f = _a.circle, circle = _f === void 0 ? false : _f, rest = __rest(_a, ["wrapper", "height", "width", "elementCount", "duration", "circle"]);
    var elements = useMemo(function () {
        return Array(elementCount)
            .fill(null)
            .map(function (_, index) { return index; });
    }, [elementCount]);
    return (React.createElement(Wrapper, __assign({}, rest, { ref: fRef }), elements.map(function (key) { return (React.createElement(SkeletonElement, { "$duration": duration, "$height": height, "$width": width, "$circle": circle, key: key, "aria-busy": "true", role: "status" })); })));
});
